import React from 'react';
import { toFormatDate } from '../../../utils/date';

interface CreationDateFieldProps {
    record?: { creationDate?: string | null };
}

/**
 * Muestra la fecha de creación de un avatar.
 *
 * `toFormatDate(undefined)` es `moment().format(...)`, que devuelve la fecha de
 * hoy. Sin esta guarda, un avatar sin `creationDate` aparecería como creado hoy.
 */
const CreationDateField: React.FC<CreationDateFieldProps> = ({ record }) => {
    const value = record?.creationDate;
    return <>{value ? toFormatDate(value) : 'N/A'}</>;
};

export default CreationDateField;
